import PagingMixins from '@/mixins/paging';
import InfiniteScroll from '@/directives/vue-infinite-scroll/directive';

export default {
	mixins: [PagingMixins],
	directives: {
		infiniteScroll: InfiniteScroll
	},
	model: {
		prop: 'scrollLock',
		event: 'scroll'
	},
	props: {
		source: {
			type: Object,
			default: () => {}
		},
		scrollLock: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			waitForRender: false
		};
	},
	computed: {
		loadingSource() {
			return false;
		},
		loadingOtherSources() {
			return false;
		},
		spinnerVariant() {
			if (!this.loadingOtherSources && this.pagingModel.page > 1) {
				return 'infinity-scroll';
			}
			return '';
		},
		hasNoResults() {
			if (this.loadingSource || this.loadingOtherSources) {
				return false;
			}

			return !this.hasResults;
		}
	},
	methods: {
		handleScroll() {
			if (this.hasPagination && !this.scrollLock) {
				this.$emit('scroll', true);
			}
		},
		resetScrollTop() {
			//for resetting the scrollTop when it's neccesary
			if (this.$refs.infiniteScroll)
				this.$refs.infiniteScroll.scrollTop = 0;
		}
	},
	updated: function() {
		this.$nextTick(function() {
			// Code that will run only after the
			// entire view has been re-rendered
			if (this.hasResults) {
				if (
					this.hasPagination &&
					!this.waitForRender &&
					this.$refs.infiniteScrollList &&
					this.$refs.infiniteScroll &&
					this.$refs.infiniteScrollList.clientHeight -
						this.$refs.infiniteScroll.clientHeight <
						0
				) {
					this.waitForRender = true;
					this.handleScroll();
				}
			}
		});
	},
	watch: {
		source: {
			deep: true,
			immediate: true,
			handler(val) {
				this.pagingModel = { ...val };
				this.waitForRender = false;
				if (val.page === 1) {
					this.resetScrollTop();
				}
			}
		}
	}
};
